<script setup lang="ts">
import HotelCardCarousel from '@components/ui/hotelPage&index/HotelCardCarousel.vue';
import type HotelPackage from '@itinerary/hotel/HotelPackage';

const hotelModule = useHotelModule();
const { isLoadingNearbyHotels, nearbyHotels } = moduleToRefs(hotelModule);
const packageSelectStore = usePackageSelectStore();
const { selectedPackages } = classToRefs(packageSelectStore);

const hotelPackage = computed(() =>
    !selectedPackages.value.length
        ? hotelModule.emptyPackage
        : (selectedPackages.value[0] as HotelPackage)
);
</script>
<template>
    <div
        v-if="isLoadingNearbyHotels || nearbyHotels.length"
        id="similar"
        class="root"
    >
        <mr-typography class="title" type="h2" size="x-large" weight="700">
            هتل‌های مشابه {{ hotelPackage.title }}
        </mr-typography>
        <HotelCardCarousel
            :items="nearbyHotels"
            hide-buttons
            no-margin
            :is-loading="isLoadingNearbyHotels"
            have-loading
            reserve-event-name="nearby-hotel-click"
            :mobile-offset-around="12"
            mobile-disable-swiper
        />
    </div>
</template>

<style lang="scss" scoped>
.root {
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    width: 100%;
    .title {
        margin-bottom: 8px;
        margin-top: 32px;
        @include mobile-only {
            margin-inline: 12px;
        }
    }
    :deep(.swiper-wrapper) {
        z-index: auto;
    }
}
</style>
